import { Component, OnInit, ViewChild } from '@angular/core';
import { LabelValuePair, ScrBaseComponent } from 'src/app/components/base.component';
import { ReportsService } from 'src/app/services/reports.service';
import { ScrAuthorizationService } from 'src/app/services/authorization.service';
import { NgForm } from '@angular/forms';
import { CheckboxChangeEvent } from "primeng/checkbox";
import { ShortCodesRole } from '../../../models/constants';
import { ConfigService } from '../../../services';
import { first } from 'rxjs';


interface DateRangeChoice extends LabelValuePair {
  expiration: string;
  paymentSummary: string;
  scTransfer: string
}
@Component({
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent extends ScrBaseComponent implements OnInit {
  brandsEnabled = true;
  CognitoGroup: typeof ShortCodesRole = ShortCodesRole;
  reportTypes: LabelValuePair[] = [];
  dateRanges: DateRangeChoice[] = [];
  filteredDateRange: DateRangeChoice[] = [];
  selectedReportType = "scExpiration";
  selectedDateRange = "next10days";
  startDate: Date | undefined;
  endDate: Date | undefined;
  minDate = new Date();
  maxDate = new Date();
  retrieveby = 'ShortCode';
  today: Date = new Date();
  includeUnpaidInvoices = false;
  unpaidInvoices = false;
  @ViewChild('reportForm', { static: false }) ReportForm!: NgForm;

  constructor(
    private reportsService: ReportsService, 
    protected authorizationService: ScrAuthorizationService,
    private configService: ConfigService) {
    super();
    this.reportTypes = [
      { label: "Short Code Expiration", value: "scExpiration" },
      { label: "Payment Summary", value: "paymentSummary" },
      { label: "Short Code List", value: "scList" },
      { label: "Brand List", value: "brandList" },
      { label: "Content Provider List", value: "contentProviderList" },
      { label: "Short Code Brand", value: "scBrand" }


    ];
    this.dateRanges = [
      { label: "Next 10 days", value: "next10days", expiration: "1", paymentSummary: "0", scTransfer: "0" },
      { label: "Next 30 days", value: "next30days", expiration: "1", paymentSummary: "0", scTransfer: "0" },
      { label: "All", value: "All", expiration: "1", paymentSummary: "0", scTransfer: "3" },
      { label: "Last 7 days", value: "Last7Days", expiration: "0", paymentSummary: "2", scTransfer: "0" },
      { label: "Current Month", value: "CurrentMonth", expiration: "0", paymentSummary: "2", scTransfer: "3" },
      { label: "Previous Month", value: "PreviousMonth", expiration: "0", paymentSummary: "2", scTransfer: "3" },
      { label: "Year-to-Date", value: "YearToDate", expiration: "0", paymentSummary: "2", scTransfer: "3" },
      { label: "Date Range", value: "DateRange", expiration: "0", paymentSummary: "2", scTransfer: "3" }
    ];
  }

  ngOnInit(): void {
    this.configService.getConfig().pipe(first()).subscribe(cfg => {
      this.brandsEnabled = cfg.brandsEnabled;
      if (!this.brandsEnabled) {
        this.reportTypes = this.reportTypes.filter(r => r.value !== 'scBrand');
      }
    });
    this.filteredDateRange = this.dateRanges.filter(range => range.expiration === "1");
    this.authorizationService.getAuthorizedGroups().subscribe(groups => {
      if ( !( groups.includes(ShortCodesRole.CarrierRegistrant) || groups.includes(ShortCodesRole.Carrier) ) ) {
        this.reportTypes.push({ label: "Short Code Transfers", value: "scTransfer" });
      }
    });

  }

  changeReportType() {
    this.startDate = undefined;
    this.endDate = undefined;
    this.minDate = new Date();
    this.maxDate = new Date();
    if (this.selectedReportType === "scExpiration") {
      this.filteredDateRange = this.dateRanges.filter(range => range.expiration === "1");
      this.selectedDateRange = "next10days";
    }
    else if (this.selectedReportType === "paymentSummary") {
      this.filteredDateRange = this.dateRanges.filter(range => range.paymentSummary === "2");
      this.selectedDateRange = "Last7Days";
    }
    else if (this.selectedReportType === "scTransfer") {
      this.filteredDateRange = this.dateRanges.filter(range => range.scTransfer === "3");
      this.selectedDateRange = "All";
    }
    if (this.selectedReportType === "scList")
      this.selectedDateRange = "";
    if (this.selectedReportType === "brandList")
      this.selectedDateRange = "";
    if (this.selectedReportType === "contentProviderList")
      this.selectedDateRange = "";
    if (this.selectedReportType === "scBrand")
      this.selectedDateRange = "";


  }

  downloadShortCodeExpiration() {
    this.reportsService.downloadShortCodeExpiration(this.selectedDateRange).subscribe(rsp => {
      if (!this.reportsService.processBlobResponseDownload(rsp)) {
        this.displayLocalizedError('Unable to download requested report.');
      }
    });
  }

  downloadShortCodeList() {
    this.reportsService.downloadShortCodeList().subscribe(rsp => {
      if (!this.reportsService.processBlobResponseDownload(rsp)) {
        this.displayLocalizedError('Unable to download requested report.');
      }
    });
  }

  downloadBrandList() {
    this.reportsService.downloadBrandList().subscribe(rsp => {
      if (!this.reportsService.processBlobResponseDownload(rsp)) {
        this.displayLocalizedError('Unable to download requested report.');
      }
    });
  }

  downloadContentProviderList() {
    this.reportsService.downloadContentProviderList().subscribe(rsp => {
         console.log("rsp:",rsp);
      if (!this.reportsService.processBlobResponseDownload(rsp)) {
        this.displayLocalizedError('Unable to download requested report.');
      }
    });
  }

  downloadList() {
    this.reportsService.downloadShortCodeList().subscribe(rsp => {
      if (!this.reportsService.processBlobResponseDownload(rsp)) {
        this.displayLocalizedError('Unable to download requested report.');
      }
    });
  }


  downloadShortCodeBrand() {
    this.reportsService.downloadShortCodeBrand().subscribe(rsp => {
      if (!this.reportsService.processBlobResponseDownload(rsp)) {
        this.displayLocalizedError('Unable to download requested report.');
      }
    });
  }
  downloadPaymentSummary() {
    let stringStart;
    let stringEnd;
    this.clearErrors();
    if (this.selectedDateRange == "DateRange") {
      if (this.startDate && !this.endDate) {
        this.displayLocalizedError('scr.endDateRequired', undefined, 'message');
        this.jumpToTop();
        return;
      }
      if (this.startDate === undefined && this.endDate === undefined) {
        return;
      }
      if (this.startDate !== undefined && this.startDate !== null)
        stringStart = this.formatDate(this.startDate);
      else
        stringStart = undefined;
      if (this.endDate !== undefined && this.endDate !== null)
        stringEnd = this.formatDate(this.endDate);
      else
        stringEnd = undefined;
    } else {
      this.startDate = undefined;
      this.endDate = undefined;
      this.minDate = new Date();
    }
    this.reportsService.downloadPaymentSummary(this.selectedDateRange, this.retrieveby, stringStart, stringEnd, this.unpaidInvoices).subscribe(rsp => {
      if (!this.reportsService.processBlobResponseDownload(rsp)) {
        this.displayLocalizedError('Unable to download requested report.');
      }
    });
  }

  downloadShortCodeTransfer() {
    let stringStart;
    let stringEnd;
    if (this.selectedDateRange == "DateRange") {
      stringStart = this.formatDate(this.startDate);
      stringEnd = this.formatDate(this.endDate);
    } else {
      this.startDate = undefined;
      this.endDate = undefined;
      this.minDate = new Date();
    }
    this.reportsService.downloadShortCodeTransfer(this.selectedDateRange, stringStart, stringEnd).subscribe(rsp => {
      if (!this.reportsService.processBlobResponseDownload(rsp)) {
        this.displayLocalizedError('Unable to download requested report.');
      }
    });
  }

  downloadReport({ form }: NgForm) {
    this.clearErrors();
    if (form.invalid)
      return;
    else if (this.selectedDateRange === 'DateRange') {
      if (!this.startDate && !this.endDate) {
        this.displayLocalizedError('scr.rangerequired', undefined, 'message');
        return;
      } else  if (this.startDate && !this.endDate) {
        this.displayLocalizedError("scr.endDateRequired", undefined, 'message');
        return;
      } else if (this.startDate && this.endDate && this.startDate > this.endDate) {
        this.displayLocalizedError('scr.enddatestartdate.invalid', undefined, 'message');
        return;
      }
    }
    if (this.selectedReportType === "scExpiration")
      this.downloadShortCodeExpiration();
    else if (this.selectedReportType === "scList")
      this.downloadShortCodeList();
    else if (this.selectedReportType === "paymentSummary")
      this.downloadPaymentSummary();
    else if (this.selectedReportType === "scTransfer")
      this.downloadShortCodeTransfer();
    else if (this.selectedReportType === "scBrand")
      this.downloadShortCodeBrand();
    else if (this.selectedReportType === "brandList")
      this.downloadBrandList();
    else if (this.selectedReportType === "contentProviderList")
      this.downloadContentProviderList();
    else {
      console.error('unknown report type ' + this.selectedReportType);
    }
  }

  formatDate(date?: Date) {
    const d = date ? new Date(date) : new Date();
    const year = d.getFullYear();
    let month = String(d.getMonth() + 1),
      day = String(d.getDate());

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [year, month, day].join('-');
  }

  includeUnpaidInvoicesCheck(e: CheckboxChangeEvent): void {
    if (!e.checked) {
      // if add to profile is false, set default to false as well.
      this.unpaidInvoices = false;
    }else
    this.unpaidInvoices = true;
  }
}
